import React, { useState, useEffect } from 'react';
import {
    FormControl,
    FormLabel,
    Select,
    Skeleton,
    Alert,
    AlertIcon,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useAuth } from '../contexts/AuthContext';
import { fetchWithAuth } from '../utils/fetchWithAuth';


const ModelSelector = ({ model, setModel }) => {
    const [modelOptions, setModelOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user } = useAuth();

    useEffect(() => {
        if (!user) {
            setIsLoading(false);
            return;
        }

        const fetchModelOptions = async () => {
            try {
                const response = await fetchWithAuth('/api/models', {
                });
                
                if (!response.ok) {
                    throw new Error('Failed to fetch model options');
                }
                
                const data = await response.json();
                setModelOptions(data);
                setError(null);
            } catch (error) {
                console.error('Error fetching model options:', error);
                setError('Failed to load model options');
            } finally {
                setIsLoading(false);
            }
        };

        fetchModelOptions();
    }, [user]);

    const handleChange = (e) => {
        setModel(e.target.value);
    };

    if (isLoading) {
        return (
            <FormControl>
                <FormLabel fontSize="sm" color="text.primary">
                    Model:
                </FormLabel>
                <Skeleton height="40px" borderRadius="md" />
            </FormControl>
        );
    }

    if (error) {
        return (
            <FormControl>
                <FormLabel fontSize="sm" color="text.primary">
                    Model:
                </FormLabel>
                <Alert status="error" size="sm" borderRadius="md">
                    <AlertIcon />
                    Error loading models
                </Alert>
            </FormControl>
        );
    }

    return (
        <FormControl>
            <Select
                value={model}
                variant="messageInput"
                onChange={handleChange}
                bg="bg.primary"
                border="1px"
                borderColor="border.primary"
                _hover={{ borderColor: "border.secondary" }}
                _focus={{
                    borderColor: "brand.500"
                }}
                fontSize={{ base: 'md', md: 'sm' }}
                size="sm"
                transitionProperty="common"
                transitionDuration="normal"
            >
                {modelOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Select>
        </FormControl>
    );
};

ModelSelector.propTypes = {
    model: PropTypes.string.isRequired,
    setModel: PropTypes.func.isRequired,
};

export default ModelSelector;